<template>
  <div class="info">
    <div class="info-list">
      <div v-for="(item, index) in config" :key="item.title">
        <div class="info-item">
          <div class="item-img">
            <img :src="item.icon" alt="icon" />
          </div>
          <div class="item-title">{{ item.title }}</div>
          <ul class="item-list" :class="`color-${index}`">
            <li
              v-for="val in item.list"
              :key="val.name"
              @click="handleClick(val)"
            >
              <span class="color"></span
              ><span class="name">{{ val.name }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from './config';
console.log(config);
export default {
  name: 'SolutionInfo',
  data: () => {
    return {
      config,
    };
  },
  methods: {
    handleClick(val) {
      this.$router.push(val.path);
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  width: 1040px;
  // height: 360px;
  height: 220px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  // margin-top: -180px;
  margin-top: -140px;
  background-color: #fff;
  // box-shadow: 0px 3px 20px 0rgba(73, 3, 3, 0.9).9);
  box-shadow: 0px 3px 30px 0px rgba(201, 201, 201, 0.9);
  border-radius: 21px;
  overflow: hidden;

  .info-list {
    display: flex;
    padding: 40px 100px;
    justify-content: space-between;
    .info-item {
      display: flex;
      flex-direction: column;
      text-align: center;
      transition: all 0.5s ease-in-out;

      &:hover {
        transform: translate3d(0, -105px, 0);

        .item-img {
          opacity: 0;
        }

        .item-list {
          opacity: 1;
        }

        .item-title {
          // border-bottom: 1px solid #eee;
          &::before {
            position: absolute;
            bottom: -10px;
            display: block;
            content: '';
            width: 100%;
            height: 1px;
            background: -webkit-linear-gradient(
              left,
              transparent,
              // rgba(255, 255, 255, 0.5),
                #0d3091,
              transparent
            );
          }
        }
      }

      .item-img {
        transition: opacity 0.5s ease-in-out;
        img {
          height: 60px;
          margin-bottom: 38px;
        }
      }

      .item-title {
        color: #333;
        font-size: 20px;
        margin-bottom: 20px;
        position: relative;
      }

      .item-list {
        text-align: left;
        opacity: 0;
        // display: none;
        li {
          color: #666;
          font-size: 16px;
          margin-bottom: 8px;
          .name {
            padding: 3px;
            transition: all 0.3s ease;
          }
        }
      }

      .color-org {
        .color {
          background-color: #0d3091;
        }

        li:hover {
          .name {
            color: #fff;
            background-color: #0d3091;
            cursor: pointer;
          }
        }
      }
      .color-hospital {
        .color {
          background-color: #0d3091;
        }

        li:hover {
          .name {
            color: #fff;
            background-color: #0d3091;
            cursor: pointer;
          }
        }
      }
      .color-healthPlatform {
        .color {
          background-color: #0d3091;
        }

        li:hover {
          .name {
            color: #fff;
            background-color: #0d3091;
            cursor: pointer;
          }
        }
      }

      .color {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin-right: 10px;
        border-radius: 50%;
      }
    }
  }
}
</style>
